document.addEventListener('DOMContentLoaded', () => {
    // Select ALL modal triggers (buttons) and modals on the page
    const modalTriggers = document.querySelectorAll('.button--popup-trigger');
    const modals = document.querySelectorAll('.button-popup-gallery__modal');

    // --- CRITICAL FIX: Move modals to the <body> immediately upon load ---
    if (document.body) {
        modals.forEach(modal => {
            document.body.appendChild(modal);
        });
    }
    // --------------------------------------------------------------------

    // Function to open the modal
    const openModal = (modalId) => {
        const modal = document.querySelector(modalId);
        if (modal) {
            modal.classList.add('is-open');
            document.body.style.overflow = 'hidden'; // Prevent body scrolling
            
            // Re-adding scrollTo(0,0) as a safeguard, though the fixed position should handle it now
            window.scrollTo(0, 0); 
            
            modal.focus(); // Set focus for accessibility
        }
    };

    // Function to close the modal
    const closeModal = (modal) => {
        modal.classList.remove('is-open');
        document.body.style.overflow = ''; // Restore body scrolling
    };

    // 1. Set up Open Listeners for all buttons
    modalTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            const modalId = trigger.getAttribute('data-modal-id');
            openModal(modalId);
        });
    });

    // 2. Set up Close Listeners for all modals
    modals.forEach(modal => {
        const closeButton = modal.querySelector('[data-modal-close]');

        // Close on X button click
        if (closeButton) {
            closeButton.addEventListener('click', () => closeModal(modal));
        }

        // Close on outside click
        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                closeModal(modal);
            }
        });

        // Close on ESC key press
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal.classList.contains('is-open')) {
                closeModal(modal);
            }
        });
    });
});